<template>
  <j-modal :title="title" width="75%" :visible="visible" :confirmLoading="confirmLoading"
    :maskClosable="false" :body-style="{ height: '650px', overflow: 'hidden', overflowY: 'scroll' }"
    @cancel="handleCancel" :okText="$t('确定')" :cancelText="$t('关闭')" :okButtonProps="{ class:{'jee-hidden': disableSubmit} }">
    <a-spin :spinning="confirmLoading">
      <div>
        <a-divider orientation="left">{{ $t('巡检任务信息') }}</a-divider>
        <detail-list>
          <detail-list-item :term="$t('任务名称')">{{model.taskName}}</detail-list-item>
          <detail-list-item :term="$t('任务类型')">{{model.taskCategory == 0?$t('临时任务'):$t('日常任务')}}</detail-list-item>
          <detail-list-item :term="$t('任务状态')">{{model.taskState == 0?$t('未分配'):model.taskState == 1?$t('已分配'):$t('结束')}}</detail-list-item>
          <detail-list-item :term="$t('计划名称')">{{model.planName}}</detail-list-item>
          <detail-list-item :term="$t('任务结束时间')">{{model.taskEndTime}}</detail-list-item>
        </detail-list>
        <!-- <div v-for="(item,index) in model.inspectionTaskRouteInnerList && model.inspectionTaskRouteInnerList" class="device-box">
          <a-divider orientation="left">巡检路线{{++index}}</a-divider>
          <detail-list>
            <detail-list-item term="路线名称">{{item.routeName}}</detail-list-item>
            <detail-list-item term="路线类型">{{item.routeType == 0?'管线':'--'}}</detail-list-item>
            <detail-list-item term="里程数">{{item.routeMileage}}</detail-list-item>
          </detail-list>
          <div v-for="(cld,cldindex) in item.inspectionTaskRouteDeviceInnerList && item.inspectionTaskRouteDeviceInnerList" class="device-box">
            <a-divider orientation="left">设备{{++cldindex}}</a-divider>
            <detail-list>
              <detail-list-item term="设备名称">{{cld.deviceName}}</detail-list-item>
              <detail-list-item term="设备经度">{{cld.detectLongitude}}</detail-list-item>
              <detail-list-item term="设备纬度">{{cld.detectLatitude}}</detail-list-item>
              <detail-list-item term="检测类型">{{cld.detectType == 0?'设备':''}}</detail-list-item>
              <detail-list-item term="检测实体">{{cld.detectEntity}}</detail-list-item>
              <detail-list-item term="检测内容">{{cld.detectContent}}</detail-list-item>
            </detail-list>
          </div>
        </div> -->
        <a-divider orientation="left">{{ $t('路线-设备信息') }}</a-divider>
        <a-table ref="table" size="middle" :scroll="{x:'true'}" bordered rowKey="id" :columns="columns1"
          :dataSource="dataSource1" :loading="loading" :pagination="false" class="j-table-force-nowrap">
          <template slot="inspectionTaksRouteDeviceFilePath1" slot-scope="text,record">
            <div style="display: flex;align-items: center;">
              <div style="width: 30px;height: 30px;cursor: pointer;margin-right: 5px;" v-for="item in record.inspectionTaksRouteDeviceFilePath" :key="item" @click="viewPicture(item)" v-if="item.type==1">
                <img v-if="item.fileType == 'image'" :src="item.url" alt="" style="width: 100%;height: 100%;"/>
                <img v-if="item.fileType == 'video'" src="@/assets/videodefault.gif" alt="" style="width: 100%;height: 100%;"/>
              </div>
            </div>
          </template>
          <template slot="inspectionTaksRouteDeviceFilePath2" slot-scope="text,record">
            <div style="display: flex;align-items: center;">
              <div style="width: 30px;height: 30px;cursor: pointer;margin-right: 5px;" v-for="item in record.inspectionTaksRouteDeviceFilePath" :key="item" @click="viewPicture(item)" v-if="item.type==2">
                <img v-if="item.fileType == 'image'" :src="item.url" alt="" style="width: 100%;height: 100%;"/>
                <img v-if="item.fileType == 'video'" src="@/assets/videodefault.gif" alt="" style="width: 100%;height: 100%;"/>
              </div>
            </div>
          </template>
        </a-table>
      </div>
      <a-modal :title="$t('预览')" :width="700" :visible="visiblePirture" :footer="null" @cancel="imghandleCancel">
        <img alt="example" style="width: 100%;height: 100%;" :src="viewUrl.url" v-if="viewUrl.fileType == 'image'"/>
        <video controls :src="viewUrl.url" alt="" style="width: 100%;height: 100%;" v-if="viewUrl.fileType == 'video'"></video>
      </a-modal>
    </a-spin>
  </j-modal>
</template>

<script>
  // import {
  //   JeecgListMixin
  // } from '@/mixins/JeecgListMixin';
  import {
    httpAction,
    getAction
  } from '@/api/manage'
  import {
    validateDuplicateValue
  } from '@/utils/util'
  import DetailList from '@/components/tools/DetailList'
  const DetailListItem = DetailList.Item
  import {
    filterDictTextByCache
  } from '@/components/dict/JDictSelectUtil';
  export default {
    // mixins: [JeecgListMixin],
    name: 'inspectionTasksDetailModal',
    components: {
      DetailList,
      DetailListItem
    },
    data() {
      return {
        title: '',
        width: 800,
        visible: false,
        disableSubmit: true,
        confirmLoading: false,
        model: {},
        url: {
          queryById: "/jeecg-engineering/inspection/inspectionTask/queryById",
          queryTableById: "/jeecg-engineering/inspection/inspectionTask/queryTableById",
        },
        // 表头
        columns1: [],
        dataSource1: [],
        loading: false,
        visiblePirture: false,
        viewUrl: {},
      }
    },
    computed: {
      columns_1() {
        return [{
            title: '#',
            dataIndex: '',
            key: 'rowIndex',
            width: 60,
            align: "center",
            customRender: (t, r, index) => {
              return parseInt(index) + 1;
            }
          },
          {
            title: this.$t('路线名称'),
            align: "center",
            dataIndex: 'routeName',
            ellipsis: true
          },
          {
            title: this.$t('设备编号'),
            align: "center",
            dataIndex: 'deviceNum',
            ellipsis: true
          },
          {
            title: this.$t('设备类型'),
            align: "center",
            dataIndex: 'deviceType',
            customRender: (t, r, indnx) => {
              return filterDictTextByCache('deviceType', t)
            },
            ellipsis: true,
          },
          {
            title: this.$t('设备名称'),
            align: "center",
            dataIndex: 'deviceName',
            ellipsis: true
          },
          {
            title: this.$t('是否存在问题'),
            align: "center",
            dataIndex: 'abnormalOrNot',
            customRender: (t, r, index) => {
              if (t == 1) {
                return this.$t('是');
              } else if (t == 2) {
                return this.$t('否');
              }
            },
            ellipsis: true
          },
          {
            title: this.$t('运行状态'),
            align: "center",
            dataIndex: 'runOrNot',
            customRender: (t, r, index) => {
              if (t == 1) {
                return this.$t('正常');
              } else if (t == 2) {
                return this.$t('异常');
              }
            }
          },
          {
            title: this.$t('问题描述'),
            align: "center",
            dataIndex: 'exceptionDescription',
            ellipsis: true,
          },
          {
            title: this.$t('巡检结果'),
            align: "center",
            dataIndex: 'isOk',
            customRender: (t, r, index) => {
              if (t == 0) {
                return this.$t('正常');
              } else if (t == 1) {
                return this.$t('异常');
              }
            }
          },
          {
            title: this.$t('解决前照片或视频'),
            align: "center",
            dataIndex: 'inspectionTaksRouteDeviceFilePath',
            scopedSlots: {
              customRender: 'inspectionTaksRouteDeviceFilePath1'
            },
            ellipsis: true,
            width:200
          },
          {
            title: this.$t('解决后照片或视频'),
            align: "center",
            dataIndex: 'inspectionTaksRouteDeviceFilePath',
            scopedSlots: {
              customRender: 'inspectionTaksRouteDeviceFilePath2'
            },
            ellipsis: true,
            width:200
          }
        ]
      },
      columns_0() {
        return [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender: (t,r,index) => {
              return parseInt(index)+1;
            }
          },
          {
            title: this.$t('路线名称'),
            align:"center",
            dataIndex: 'routeName',
            ellipsis:true
          },
          {
            title: this.$t('设备编号'),
            align:"center",
            dataIndex: 'deviceNum',
            ellipsis:true
          },
          {
            title: this.$t('设备类型'),
            align:"center",
            dataIndex: 'deviceType',
            customRender: (text) => {
              return filterDictTextByCache('deviceType', text)
            },
            ellipsis:true
          },
          {
            title: this.$t('设备名称'),
            align:"center",
            dataIndex: 'deviceName',
            ellipsis:true
          },
          {
            title: this.$t('设备经度'),
            align:"center",
            dataIndex: 'detectLongitude',
            ellipsis:true
          },
          {
            title: this.$t('设备纬度'),
            align:"center",
            dataIndex: 'detectLatitude',
            ellipsis:true
          },
          {
            title: this.$t('备注'),
            align:"center",
            dataIndex: 'remark'
          }
        ]
      }
    },
    methods: {
      init(row) {
        this.title = this.$t('详情');
        this.visible = true;
        getAction(this.url.queryById, {
          id: row.id
        }).then(res => {
          this.model = res.result;
          if(this.model.taskState == 0){
            this.columns1 = this.columns_0;
          }else{
            this.columns1 = this.columns_1;
          }
        });
        this.loading = true;
        getAction(this.url.queryTableById, {
          id: row.id
        }).then(res => {
          if (res.success) {
            this.dataSource1 = res.result;
            this.loading = false;
          }
        });
      },
      close() {
        this.$emit('close');
        this.visible = false;
      },
      handleCancel() {
        this.close()
      },
      // 预览图片
      viewPicture(item){
        this.visiblePirture = true;
        this.viewUrl = item;
      },
      imghandleCancel(){
        this.visiblePirture = false;
      }
    }
  }
</script>
<style scoped>
</style>